import type { KeyboardEvent } from "react";

function filterKeyEnter(handler: (event: KeyboardEvent) => void) {
    return (e: KeyboardEvent) => {
        if (e.key === "Enter") {
            handler(e);
        }
    };
}

export function accessibleOnClick(handler: () => void) {
    return {
        role: "button",
        onKeyDown: filterKeyEnter(handler),
        tabIndex: 0,
        onClick: handler,
    };
}
